import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { MarketBanner } from '@market/react';

export const CART_BANNER_CONFIGS = {
  GENERIC_ERROR: {
    key: 'error.api.generic',
    variant: 'critical',
  },
  K1A_SUBSCRIPTION_INELIGIBLE: {
    key: 'notice.software.cart.k1a_subscription_ineligible',
    variant: 'critical',
  },
  K1A_SUBSCRIPTION_REQUIRED: {
    key: 'notice.software.cart.k1a_subscription_required',
    variant: 'critical',
  },
  COVID_DELAY: {
    key: 'notice.covid_delay',
    variant: 'warning',
  },
  CA_STRIKE: {
    key: 'notice.ca_strike',
    variant: 'warning',
  },
  JP_EARTHQUAKE_DELAY: {
    key: 'notice.jp_earthquake_delay',
    variant: 'warning',
  },
  JP_TYPHOON_DELAY: {
    key: 'notice.jp_typhoon_delay',
    variant: 'warning',
  },
  FINANCING_INELIGIBLE_ITEM: {
    key: 'notice.financing_ineligible_item',
    variant: 'warning',
  },
  FINANCING_UNAVAILABLE: {
    key: 'notice.financing_unavailable',
    variant: 'warning',
  },
  HOLIDAY_DELAY: {
    key: 'notice.holiday_delay',
    variant: 'warning',
  },
  IDV_FAILED: {
    key: 'notice.idv_failed',
    variant: 'warning',
  },
  IDV_REQUIRED_LOGGED_IN: {
    key: 'notice.idv_required_logged_in',
    variant: 'info',
  },
  IDV_REQUIRED_GUEST: {
    key: 'notice.idv_required_guest',
    variant: 'info',
  },
  IDV_REQUIRED_RENTAL: {
    key: 'notice.idv_required_rental',
    variant: 'critical',
  },
  INELIGIBLE_ITEM: {
    key: 'notice.ineligible_item',
    variant: 'critical',
  },
  MISCELLANEOUS_DELAY: {
    key: 'notice.miscellaneous_delay',
    variant: 'warning',
  },
  PROCESSING_DELAY: {
    key: 'notice.processing_delay',
    variant: 'warning',
  },
  PROMOTION_DELAY: {
    key: 'notice.promotion_delay',
    variant: 'warning',
  },
  WEATHER_DELAY: {
    key: 'notice.weather_delay',
    variant: 'warning',
  },
  SOFTWARE_WITHOUT_HARDWARE: {
    key: 'notice.software.cart.software_without_hardware',
    variant: 'warning',
  },
  SOFTWARE_ACTIVE_SUBSCRIPTION: {
    key: 'notice.software.cart.software_active_subscription',
    variant: 'warning',
  },
  SOFTWARE_FREE_TRIAL_ACTIVE: {
    key: 'notice.software.cart.software_free_trial_active',
    variant: 'info',
  },
  SOFTWARE_FREE_TRIAL_EXPIRED: {
    key: 'notice.software.cart.software_free_trial_expired',
    variant: 'info',
  },
  SOFTWARE_SUBSCRIPTION_PAUSED: {
    key: 'notice.software.cart.software_subscription_paused',
    variant: 'warning',
  },
  SOFTWARE_SUBSCRIPTION_PRESALE: {
    key: 'notice.software.cart.software_subscription_presale',
    variant: 'warning',
  },
  SOFTWARE_SUBSCRIPTION_WITH_ACTIVE_SUPERSET: {
    key: 'notice.software.cart.software_subscription_with_active_superset',
    variant: 'warning',
  },
  IDV_SUCCESS: {
    key: 'notice.checking.idv_success',
    variant: 'success',
  },
  CHECKING_NOT_ACCOUNT_OWNER: {
    key: 'notice.checking.not_account_owner',
    variant: 'critical',
  },
  CHECKING_HAS_SQUARE_CHECKING: {
    key: 'notice.checking.has_square_checking',
    variant: 'critical',
  },
  CHECKING_IDV_FAILED: {
    key: 'notice.checking.idv_failed',
    variant: 'critical',
  },
  XMAS_HOLIDAY_DELAY: {
    key: 'notice.xmas_holiday_delay',
    variant: 'warning',
  },
};

const CartBanner = ({ config, footnote = '', ...translationOptions }) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();

  if (!config) {
    return null;
  }

  const { key, variant } = config;

  return (
    i18n.exists(key) && (
      <MarketBanner variant={variant} style={{ margin: theme.spacing(2, 0) }}>
        <p
          data-market-features="html-styles"
          dangerouslySetInnerHTML={{
            __html: `${t(key, translationOptions)}<sup>${footnote}</sup>`,
          }}
        />
      </MarketBanner>
    )
  );
};

export default CartBanner;
